// MediaMTXPlayer.jsx
import React from 'react';
import PropTypes from 'prop-types';

const MediaMTXPlayer = ({ url, cameraName }) => {
  return (
    <div className="videoPlaer_wrapper">
      <iframe
        title={`camera-${cameraName || 'feed'}`}
        src={url}
        width="100%"
        height="400"
        frameBorder="0"
        allow="autoplay; fullscreen; camera; microphone"
        allowFullScreen
        style={{
          border: "none",
          background: "#000",
          borderRadius: "4px",
          display: "block",
        }}
      />
      {cameraName && <p className="camera_details">{cameraName}</p>}
    </div>
  );
};

MediaMTXPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  cameraName: PropTypes.string,
};

MediaMTXPlayer.defaultProps = {
  cameraName: '',
};

export default MediaMTXPlayer;